import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RouteComponentProps, Redirect, Route, RouteProps } from 'react-router';
import { RoutePath } from './RoutePath';
import { StoreState } from '../store';

//#region Props & State
interface GuestStateProps {
    readonly isGuest: boolean;
}
interface GuestDispatchProps { }
interface GuestProps extends GuestStateProps, GuestDispatchProps {
    readonly component: React.ComponentClass<any> | React.StatelessComponent<any>; // tslint:disable-line
    readonly [rest: string]: any // tslint:disable-line
}
interface GuestState { }
//#endregion

class GuestRoute extends React.Component<GuestProps, GuestState> {

    render() {
        const { isGuest, component, ...rest } = this.props;
        const Component = component;
        // tslint:disable-next-line
        const render = (renderProps: RouteComponentProps<any>) => {
            let element = (
                <Redirect
                    to={{
                        pathname: RoutePath.HomePage,
                        state: { from: renderProps.location }
                    }}
                />
            );

            if (isGuest) {
                element = <Component {...renderProps} />;
            }

            return element;
        };

        return <Route {...rest} render={render} />;
    }
}

//#region Connect
const mapStateToProps = (state: StoreState): GuestStateProps => ({
    isGuest: state.auth == null
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({});

export default connect<GuestStateProps, GuestDispatchProps, RouteProps>(mapStateToProps, mapDispatchToProps)(GuestRoute);
//#endregion



// WEBPACK FOOTER //
// ./src/routes/GuestRoute.tsx